import { createSlice } from '@reduxjs/toolkit';
import { ApiPaginationResponse } from 'src/components/ui/Table/Table.interface';
import {
  PRODUCT_SLICE,
  setErrorsTable,
  setProduct,
  setProductList,
} from 'src/store/actions/productActions';
import { Error } from 'src/store/models/Errors';
import { Product } from 'src/store/models/Product';

export interface ProductState {
  productList: ApiPaginationResponse<Product[], void>;
  productDetails: Product;
  errors: Error[];
}

const initialState: ProductState = {
  productList: {
    data: [],
    count: 0,
    ctx: null,
  },
  productDetails: null,
  errors: [],
};

const productSlice = createSlice({
  name: PRODUCT_SLICE,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(setProduct, (state, action) => {
        state.productDetails = action.payload;
      })
      .addCase(setProductList, (state, action) => {
        state.productList = action.payload;
      })
      .addCase(setErrorsTable, (state, action) => {
        state.errors = action.payload;
      });
  },
});

export default productSlice.reducer;
